import {
    SET_RESOURCES_IN_HOUR,
    SET_RESOURCES_IN_HOUR_ERROR,
    SET_LEVELS_IN_PLACE_BY_ENTITITES,
    SET_RESOURCES_IN_HOUR_LOADING
} from "./types";

const WidgetResourcesInHourReducer = (state, action) => {
    const { type, payload } = action;
    switch (type) {
        case SET_RESOURCES_IN_HOUR:
            return {
                ...state,
                resources: payload,
                isFetching: false,
                error: {
                    ok: false,
                    text: ''
                }
            }
        case SET_LEVELS_IN_PLACE_BY_ENTITITES:
            return {
                ...state,
                resourcesInPlaceByEntities: { ...state.resourcesInPlaceByEntities, levels: payload },
            }
        case SET_RESOURCES_IN_HOUR_ERROR:
            return {
                ...state,
                resources: payload.resources,
                isFetching: false,
                error: payload.error
            }
        case SET_RESOURCES_IN_HOUR_LOADING:
            return {
                ...state,
                resources: [],
                isFetching: true,
                error: {
                    ok: false,
                    text: ''
                }
            }
        default:
            return state;
    }
}

export default WidgetResourcesInHourReducer